import { BillInsuranceActivationModal } from "@features/BillInsuranceActivationModal/BillInsuranceActivationModal";
import { useModalStore } from "@store/modal/modal";
import { useChubbBillInsuranceOrdersQuery } from "@services/insurance/queries";

export const useBillInsuranceActivationModal = () => {
  const { create } = useModalStore();
  const { data: chubbBillInsuranceOrdersData } =
    useChubbBillInsuranceOrdersQuery();

  const openBillInsuranceActivationModal = (
    preselectedJointBillServiceId?: number,
  ) => {
    if (!chubbBillInsuranceOrdersData) {
      return;
    }

    create((modalProps) => (
      <BillInsuranceActivationModal
        chubbBillInsuranceOrdersData={chubbBillInsuranceOrdersData}
        preselectedJointBillServiceId={preselectedJointBillServiceId}
        {...modalProps}
      />
    ));
  };

  return { openBillInsuranceActivationModal };
};
